module.exports = __webpack_public_path__ + "static/media/04_quote_desktop.dfa8b630.jpg";